<template>
  <div v-if="institutionsTenant.length">
    <p class="lead text-center font-medium-3">
      {{ $tc("institutions.title", 1) }}
    </p>
    <b-form>
      <validation-provider
        #default="validationContext"
        name="institutions"
      >
        <b-form-group
          class="text-capitalize"
          :label="$t('institutions.select')"
          label-for="institutions"
        >
          <v-select
            v-model="institutions"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :clearable="false"
            label="name"
            :options="institutionsTenant"
            multiple
            :disabled="loading"
            @input="institutionSelected($event)"
          />
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
    </b-form>
  </div>
</template>

<script>
import {computed, onMounted, ref} from '@vue/composition-api';
import {ValidationProvider, ValidationObserver} from "vee-validate";
import {useToast} from "vue-toastification/composition";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import vSelect from 'vue-select';
import Ripple from "vue-ripple-directive";
import store from "@/store";

export default {
  props: {
    alarm: Object,
    tenant: Object
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  directives: {
    Ripple,
  },
  setup(props) {
    //HOOKS
    onMounted(async () => {
      store.commit('tenant/setInstitutions', []);

      await getInstitutions();
      await checkInstitutions()
    });

    //COMPOSABLES
    const toast = useToast();

    //DATA
    const institutionsAlarm = ref({
      id_alarm: null,
      institutions: []
    });

    const institutionsTenant = ref([]);

    //COMPUTED
    const institutions = computed({
      get: () => store.getters['tenant/getInstitutions'],
      set: (newValue) => store.commit('tenant/setInstitutions', newValue)
    });

    const institutionsOptions = computed(() => {

      const {institutions = []} = props.tenant;

      return institutions;
    });

    const loading = computed(() => store.getters['tenant/getLoading']);

    //METHODS
    const checkInstitutions = async () => {
      store.commit('tenant/setLoading', true);

      await store.dispatch('institutions_tenant/getByAlarm', props.alarm.id)
        .then(response => {
          const {data} = response;

          if (data.length) {
            store.commit('tenant/setInstitutions', data);
          }
        })
        .catch(() => {
          store.commit('tenant/setInstitutions', []);
        })
        .finally(() => {
          store.commit('tenant/setLoading', false);
        });
    }

    const getInstitutions = async () => {
      const params = { id_tenant: props.tenant.id }

      await store.dispatch('institutions_tenant/getInstitutionsByTenant', params)
        .then(response => {
          const { data } = response;

          institutionsTenant.value = data;
        })
        .catch(() => {
          institutionsTenant.value = [];
        });
    }

    const institutionSelected = async (values) => {
      store.commit('tenant/setLoading', true);

      const institutionsSelect = (values.length)
        ? values.map(bi => bi.id)
        : [];

      const params = {
        id_alarm: props.alarm.id,
        institutions: institutionsSelect
      }

      await axios.post('/v1/alarm/institutions', params)
        .then(response => {
          const {data} = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: error.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          })
        })
        .finally(() => {
          store.commit('tenant/setLoading', false);
        });
    }

    return {
      loading,
      institutionsAlarm,
      institutionsTenant,

      institutions,
      institutionsOptions,

      institutionSelected
    }
  }
}
</script>


